<template>
  <div id="videoPreview2" :class="previewClass"></div>
</template>

<script>
import Player from "xgplayer";
import FlvPlayer from "xgplayer-flv";
export default {
  name: "mp4Preview",
  data() {
    return {};
  },
  created() {
    // console.log("初始化mp4Preview预览组件");
    this.$nextTick(() => {
      this.initPlayer();
    });
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.previewData.position;
    }
  },
  methods: {
    initPlayer() {
      let style = {
        width: "460px",
        height: "280px"
      };
      if (this.previewData.position === "fullscreen") {
        style = {
          width: window.innerWidth + "px",
          height: window.innerHeight + "px"
        };
        window.addEventListener("resize", function() {
          document.getElementById("videoPreview2").style.height =
            window.innerHeight + "px";
        });
      } else if (this.previewData.position === "fullscreen-top") {
        style = {
          width: window.innerWidth + "px",
          height: window.innerHeight + "px"
        };
        window.addEventListener("resize", function() {
          document.getElementById("videoPreview2").style.height =
            window.innerHeight + "px";
        });
      } else if (this.previewData.position === "inside") {
        style = {
          width: "460px",
          height: "280px"
        };
      }
      const params = Object.assign(style, {
        id: "videoPreview2",
        url: this.previewData.preview_path,
        lang: "zh-cn",
        playsinline: false,
        // autoplay: true,
        playbackRate: [0.5, 1, 1.5, 2],
        closeVideoClick: false,
        keyShortcut: "on",
        download: false,
        cssFullscreen: true
      });
      if (this.previewData.file_ext === "flv") {
        params.cors = true;
        params.isLive = false;
        params.preloadTime = 30;
        params.minCachedTime = 5;
        this.player = new FlvPlayer(params);
      } else {
        this.player = new Player(params);
      }
    }
  },
  destroyed() {
    // console.log("销毁mp4Preview预览组件");
    if (this.player) {
      this.player.destroy();
    }
    this.$store.commit("setPreviewData", {
      preview_path: "",
      previewer: "unknowPreview"
    });
  }
};
</script>

<style scoped>
.preview-fullscreen {
  width: 100%;
  height: 100%;
}
.preview-fullscreen-top {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.preview-inside {
  width: 460px;
  height: 280px;
}
</style>